import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LogService } from '../../services/log.service';
import { environment } from '../../../environments/environment';
import { PrivacyNoticeService } from 'app/services/privacy.service';

@Component({
  selector: 'app-session-expire-dialog',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Session Timeout Warning</h4>
    </div>
    <div class="modal-body">
      <p>Your session will expire in {{currentExpirationInMillis / 1000}} seconds. {{this.extendMessage}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" *ngIf="this.isExtendButtonVisible" class="btn btn-primary" (click)="close()">Extend Session</button>
      <button type="button" class="btn" (click)="dismiss()">Log out</button>
    </div>
  `
})
export class SessionExpireDialogComponent implements OnInit {
  private readonly maxExpirationInMillis =
    environment.settings.session_timer.modal.timeout;
  currentExpirationInMillis = this.maxExpirationInMillis;
  public isExtendButtonVisible=true;
  public extendMessage='Would you like to extend it?'
  private timer: number;

  constructor(private log: LogService,
    private privacyService: PrivacyNoticeService,
    public activeModal: NgbActiveModal) {}

  ngOnInit() {
    const intervalInMillis = 1000;
    this.timer = window.setInterval(() => {
      this.currentExpirationInMillis -= intervalInMillis;
      if (this.currentExpirationInMillis <= 0) {
        this.dismiss();
      }
    }, intervalInMillis);
    if (this.privacyService.isPrivacyWindowOpen()){
      this.isExtendButtonVisible=false;
      this.extendMessage=''
    }else{
      this.isExtendButtonVisible=true;
      this.extendMessage='Would you like to extend it?'
    }
  }

  close() {
    window.clearInterval(this.timer);
    this.activeModal.close();
  }

  dismiss() {
    window.clearInterval(this.timer);
    this.privacyService.setPrivacyNoticeClose();
    this.activeModal.dismiss();
  }
}
